import { render, staticRenderFns } from "./DealerTabs.vue?vue&type=template&id=44483969&"
import script from "./DealerTabs.vue?vue&type=script&lang=js&"
export * from "./DealerTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports